import React from 'react';
import Checkbox from '../FormFields/Checkbox';
import { Pagination as RsuitePagination, SelectPicker } from 'rsuite';
import Breakpoint from 'react-socks';

function Pagination(props) {
  return (
    <React.Fragment>
      <div className="p-2 text-base md:text-lg lg:text-xl whitespace-no-wrap">Offers found: {props.totalCount}</div>
      <div className="flex flex-shrink-0 items-center flex-col md:flex-row">
        <div className="flex-none">
          <RsuitePagination activePage={props.pagenumber} pages={props.totalPages}
            ellipsis={props.ellipsis} next={props.next} prev={props.prev}
            boundaryLinks={props.boundaryLinks}
            maxButtons={props.maxButtons} size={props.size}
            onSelect={props.onPageChange} />
        </div>
        <Breakpoint md up>
          <div className="">
            <span className="px-3 pt-1">
              <SelectPicker
                data={[
                  { value: '5', label: '5' },
                  { value: '10', label: '10' },
                  { value: '20', label: '20' },
                  { value: '50', label: '50' },
                  { value: '5000', label: 'All' },
                ]}
                id="pagesize"
                placeholder="pagesize"
                size="xs"
                searchable={false}
                defaultValue={'10'}
                appearance='default'
                cleanable={false}
                value={props.pagesize.toString()}
                onChange={props.onPagesizeChange}
              />
            </span>
            <span className="pr-2 pt-1" >
              <SelectPicker
                data={props.sortbyList}
                labelKey="text"
                valueKey="key"
                id="orderby"
                placeholder="sortby"
                searchable={false}
                cleanable
                value={props.sortby}
                onChange={props.onSortByChange}
              />
            </span>
            <span className="pt-2">
              <Checkbox
                wrapperClass="inline"
                name="sortdescending"
                checkedText="Descending"
                uncheckedText="Ascending"
                value={props.sortdescending}
                onChange={props.onSortDescendingChange}
              />
            </span>
          </div>
        </Breakpoint>
      </div>
    </React.Fragment>
  );
}

export default Pagination;